module.exports = __webpack_public_path__ + "static/img/shcygn8.1f08874.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/shcygn8.png
// module id = 378
// module chunks = 0